<template>
  <div id="app">
    <div id="background"></div>
    <hello v-if="storage.hello_status"></hello>
    <menu v-if="storage.menu_status"></menu>
    <feed v-if="storage.feed_status" ></feed>
    <weibo v-if="storage.weibo_status" ></weibo>
  </div>
</template>

  <script>
    import Hello from './components/Hello'
    import Menu from './components/Menu'
    import Feed from './components/Feed'
    import Weibo from './components/WeiBo'
    import lstore from './store.js'

    export default {
      data() {
        return {
          state: 'default',
          storage: lstore
        }
      },

      components: {
        Hello,
        Menu,
        Feed,
        Weibo
      },

      watch: {
         'storage.feed_status': function () {
           
         }
       }
    }
  </script>

  <style>
    html {
      width: 100%;
      height: 100%;
    }

    body {
      display: flex;
      align-items: center;
      justify-content: center;
      height: 100%;
    }
    #background{
      position: absolute; 
      z-index: -1;
      width: 100%;
      height: 100%;
    }
    #app {
      position: relative;
      color: #2c3e50;
      width: 100%;
      height: 100%;
    }

  </style>



// WEBPACK FOOTER //
// App.vue?0ed83925